import api from "../../services/api";

export default class BRyHUB {
    static async authorize({ id = null, table = null, multipleSubscriptions = false, user_id = null }) {
        try {
            let body = { signData: `${id}${table}`, };

            const response = await api.post("/bry/user/sign-cloud", body);

            let { error, authorize_url } = response.data;

            if (!error && authorize_url) {

                if (multipleSubscriptions && user_id) {
                    authorize_url = `${authorize_url}multiple${user_id}`
                }

                setTimeout(() => {
                    window.open(authorize_url, "_blank");
                }, 1500);
            }
        } catch (error) {
            console.log(error);
        }
    }
}